
export * from "./parameters/keyvaluepair";
export * from "./Parameters/ErrorData";
export * from "./login/loginmodel";

export * from "./login/forgotpasswordmodel";
export * from "./login/signupmodel";
export * from "./login/changepasswordmodel";

export * from "./usersecurity/userdata";
export * from "./usersecurity/signupdata";
export * from "./usersecurity/forgotpassworddata";
export * from "./usersecurity/changepassworddata";

export * from "./appointments/appointmentsdatamodel";
export * from "./userprofile/userprofiledatamodel";
export * from "./dashboard/dashboarddatacontainer";
export * from "./dashboard/NewsAndPromotions";
export * from "./searchdashboard/filesearch";
export * from "./searchdashboard/searchdashboarddatacontainer";

export * from "./allergy/allergydatamodel";
export * from "./allergy/allergydatacontainer";

export * from "./insurance/insurancedatamodel";
export * from "./insurance/insurancedatacontainer";

export * from "./feedback/feedbackdatamodel";   
export * from "./feedback/feedbackdatacontainer"; 

export * from "./immunization/immunizationdatamodel";
export * from "./immunization/immunizationdatacontainer";

export * from "./prescription/prescriptiondatamodel";
export * from "./prescription/prescriptiondatacontainer";

export * from "./radiology/radiologydatacontainer";
export * from "./radiology/radiologydatamodel";
export * from "./radiology/radiologyinstructionsdatamodel";
export * from "./radiology/radiologyresultsdatamodel";

export * from "./booking/bookingdatacontainer";
export * from "./booking/bookingdatamodel";
export * from "./booking/doctordatamodel";
export * from "./booking/departmentdatamodel";
export * from "./booking/locationdatamodel";
export * from "./booking/bookingdoctordatacontainer";
export * from "./booking/GeneralBookingModel";
export * from "./booking/SlotBookingModel";
export * from "./booking/PaymentDetailsModel";
export * from "./booking/PaymentDetailsDataContainer";

export * from "./booking/requestparam";
export * from "./booking/responseParam";
//export * from "./booking/date";
export * from "./booking/response";

export * from "./UserProfile/LoggedInUserData";

export * from "./medicalreport/medicaldatacontainer";
export * from "./medicalreport/medicaldata";
export * from "./medicalreport/MedicalsSubData";

export * from "./MedicalRequest/MedicalRequestDataContainer";
export * from "./MedicalRequest/DoctorDetailsData";
export * from "./MedicalRequest/LanguageData";
export * from "./MedicalRequest/RelationData";
export * from "./MedicalRequest/PriorityData";
export * from "./MedicalRequest/MedicalRequestDataModel";

export * from "./lab/labdatamodel";
export * from "./lab/labdatacontainer";
export * from "./lab/ViewLabInstructions";
export * from "./lab/LabResults";
export * from "./lab/LabResultsContainer";
export * from './lab/labinstructionmodel';
export * from './lab/labresultdatamodel';
export * from './lab/UrineCultureGrowth';

export * from './servicepayment/paytabspaymentdetails';

export * from "./VisitHistory/VisitHistoryDataModel";
export * from "./VisitHistory/VisitHistoryDataContainer";

export * from "./VisitHistory/RecentAppointmentsDataModel";
export * from "./VisitHistory/RecentAppointmentDataContainer";


export * from "./Registration/MandatoryFieldsDataModel";
export * from "./Registration/MandatoryFieldsContainer";
export * from "./Registration/NationalityModel";
export * from "./Registration/TitleModel";
export * from "./Registration/AreaDataModel";
export * from "./Registration/RelationFields";
export * from "./Registration/ReligionDetails";
export * from "./Registration/BloodGroups";
export * from "./Registration/RegistrationDataModel";
export * from "./Registration/AlternateType";
export * from "./Registration/Gender";
export * from "./Registration/ProviderCode";

export * from "./AdvancePayment/PaymentHistory";
export * from "./AdvancePayment/PaymentHistoryContainer";

export * from "./Navigation/NavigationMenus";

export * from "./Procedure/ProcedureDataModel"; 
export * from "./Procedure/ProcedureResultDataModel";
export * from "./Procedure/ProcedureResults";
export * from "./Procedure/Procedureinstructionmodel";
export * from "./Procedure/ProcedureDataContainer";


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/index.ts